export interface WebSiteCustomerService {
  subscribeForCustomer(tag:string, callback:(c:Customer)=>void)
  subscribeForCustomerNotAvailable(tag:string, callback:()=>void)
  subscribeForCountry(tag:string, callback:(country:string)=>void)
  setCurrentCountry(country:string)

  login(email:string, password:string, saveLogin:boolean):Promise<Customer>
  verify(): Promise<Customer>
  logout():Promise<boolean>
  resetPassword(email:string):Promise<boolean>
  setPassword(newPassword:string, token:string):Promise<boolean>
  changePassword(oldPassword:string, newPassword:string):Promise<boolean>

  likeProduct(productId: string, variantId: string): Promise<boolean>
  dislikeProduct(productId: string, variantId: string): Promise<boolean>
  getLikesForCustomer(): Promise<Like[]>

  shareItem(type: string, url: string): Promise<boolean>;
}

export class Customer {
  public id: string;
  public createdAt: Date;
  public updatedAt: Date;
  public countryCode: string;
  public email: string;
  public emailVerified: boolean;
  public loyalty: boolean;
  public profile: Profile;
  public preferences: Preferences;

  constructor (data:any) {
    this.id            = data.id;
    this.createdAt     = data.createdAt ? new Date (data.createdAt) : undefined;
    this.updatedAt     = data.updatedAt ? new Date (data.updatedAt) : undefined;
    this.countryCode   = data.countryCode;
    this.email         = data.email;
    this.emailVerified = data.emailVerified;
    this.loyalty       = data.loyalty;

    if (data.profile) {
      this.profile = new Profile(data.profile);
    }

    if (data.preferences) {
      this.preferences = new Preferences(data.preferences);
    }
  }
}

export class Session {
  public token: string;
  public customerId: string;
  public validUntil: Date;

  constructor (data:any) {
    this.token         = data.token;
    this.customerId    = data.customerId;
    this.validUntil    = data.validUntil ? new Date (data.validUntil) : undefined;
  }
}

export class CustomerWithSession {
  public customer: Customer;
  public session: Session;

  constructor (data:any) {
    if (data.customer) {
      this.customer = new Customer(data.customer);
    }

    if (data.session) {
      this.session = new Session(data.session);
    }
  }
}


export class Profile {
  public firstName         : string;
  public lastName          : string;
  public birthday          : Date;
  public gender            : Gender;
  public size              : string;
  public avatarUrl         : string;
  public storeId           : string;
  public phoneNumber       : string;
  public address           : Address;

  constructor (data:any) {
    this.firstName     = data.firstName;
    this.lastName      = data.lastName;
    this.birthday      = data.birthday ? new Date (data.birthday) : undefined;
    this.gender        = data.gender;
    this.size          = data.size;
    this.avatarUrl     = data.avatarUrl;
    this.storeId       = data.storeId;
    this.phoneNumber   = data.phoneNumber;


    if (data.address) {
      this.address = new Address(data.address);
    }
  }
}

export class Address {
  public street     : string;
  public postalCode : string;
  public city       : string;
  public country    : string;


  constructor (data:any) {
    this.street     = data.street;
    this.postalCode = data.postalCode;
    this.city       = data.city;
    this.country    = data.country;
  }
}

export class Preferences {
  public optInConfirmed: boolean;
  public optInEmailAdvertisementConsent: boolean;
  public optInEmailChannelNewsletter: boolean;
  public optInEmailChannelLoyalty: boolean;
  public optInEmailChannelWomensFashion: boolean;
  public optInEmailChannelMensFashion: boolean;


  constructor(data: any) {
    this.optInConfirmed = data.optInConfirmed;
    this.optInEmailAdvertisementConsent = data.optInEmailAdvertisementConsent;
    this.optInEmailChannelNewsletter = data.optInEmailChannelNewsletter;
    this.optInEmailChannelLoyalty = data.optInEmailChannelLoyalty;
    this.optInEmailChannelWomensFashion = data.optInEmailChannelWomensFashion;
    this.optInEmailChannelMensFashion = data.optInEmailChannelMensFashion;
  }
}

export enum CustomerShareType {
  product = "product",
  collection = "collection",
  loyalty = "loyalty",
}

export enum Gender {
  Male = "MALE",
  Female = "FEMALE",
  NA = "N_A",
}

export class Like {
  public type: string;
  public itemId: string;

  constructor(data: any) {
    this.type = data.type;
    this.itemId = data.itemId;
  }
}